export function makeScrollToBottom(scrollToBottom) {
    return {
        scrollToBottom
    };
}
export function makeOpenMandateReauth(openMandateReauth) {
    return {
        openMandateReauth
    };
}
export function makeAfterEmailVerification(afterEmailVerification) {
    return {
        afterEmailVerification
    };
}
